define(
    'viewmodels/controller',[
        "durandal/app",
        "plugins/router",
        "services/session",
        "services/log"
    ],
    function (rootApp, router, session, log) {
        var qBusyCount = 0;
        var qNavCount = 0;
        var busyTitle = 'Processing';

        var controller = {
            title: ko.observable(''),
            router: router,
            titleBusy: ko.observable(busyTitle),            
            isSuspended: ko.observable(false),

            _isBusy: ko.observable(false).extend({ notify: 'always'}),
            _isNavigating: ko.observable(false)            
        };

        controller.activate = function () {
            controller.router.map([
                { route: "suspended",       moduleId: "suspended",          title: "Subscription Suspended" },
                { route: "trialcancelled",  moduleId: "trialcancelled",     title: "Subscription Cancelled" },
                { route: "status/:id",      moduleId: "status",             title: "Server Status" },
                { route: "login",           moduleId: "login",              title: "Login" },
                { route: "logout",          moduleId: "logout",             title: "Logout" },
                { route: "reset/:id",       moduleId: "reset",              title: "Reset Password" },
                { route: "shared/:id",      moduleId: "shared",             title: "Shared Documents" },
                { route: "message",         moduleId: "message",            title: "Message" },
                { route: "upload/:id",      moduleId: "upload",             title: "Upload Document" },
                { route: "download/:id",    moduleId: "download",           title: "Download Document",         display: session.isAuthenticated },
                { route: "*details",        moduleId: "secured/app",        title: "Fileplan",                  display: session.isAuthenticated }
            ]);

            router.mapUnknownRoutes('secured/app', 'not-found');

            return router.activate();
        };
        controller.isBusy = function (d, m, a) {
            if (d) {
                qBusyCount++;
                if (typeof a == "undefined") a = 3000;
                
                setTimeout(function () {
                    if (qBusyCount > 0) {
                        if (m) controller.titleBusy(m);
                        controller._isBusy(true);
                    }
                }, a);

            } else {
                qBusyCount--;

                if (qBusyCount < 0)
                    qBusyCount = 0;

                setTimeout(function () {
                    if (qBusyCount < 1) {
                        controller._isBusy(false);
                        controller.titleBusy(busyTitle)
                    }
                }, 1500);
            }
        };
        controller.isNavigating = function (d, m) {            
            if (d) {
                if (m)
                    controller.title(m);
                else
                    controller.title('');

                qNavCount++;

                setTimeout(function () {
                    if (qNavCount > 0)
                        controller._isNavigating(true);
                }, 1000);
            } else {
                qNavCount--;

                if (qNavCount < 0)
                    qNavCount = 0;

                setTimeout(function () {
                    if (qNavCount < 1)
                        controller._isNavigating(false);
                }, 800);
            }
        };

        //rootApp.isBusy.subscribe(function (d) {
            //controller.isSuspended(session.suspendBusy);

            //if (d && controller._isBusy() && controller.isSuspended()) {
            //    controller.isSuspended(false);
            //}

            //controller.isBusy(d);
        //});

        //rootApp.isBusy.subscribe(function (d) {
        //    controller.isSuspended(session.suspendBusy);
            
        //    if (d && controller.isBusy() && controller.isSuspended()) {
        //        controller.isSuspended(false);
        //    }

        //    controller.isBusy(d);
        //});     

        return controller;
    }
);

